import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { loadConfluencePermissionsService } from '../../../services/whiteboards-entrypoint-experiment/index.tsx';
import { LOAD_APP_DATA_REQUEST } from '../../../state/actions/app/index.tsx';
import { hasConfluenceAccessEstablished } from '../../../state/actions/whiteboards-entrypoint-experiment/index.tsx';
import type { ActionsObservable } from '../../../state/types.tsx';

const loadHasAccessToConfluence = () =>
	loadConfluencePermissionsService().map(hasConfluenceAccessEstablished);

export const loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic = (
	action$: ActionsObservable,
) => action$.ofType(LOAD_APP_DATA_REQUEST).flatMap(() => loadHasAccessToConfluence());
